export const SUPPORTED_LOCALES = ['en', 'de'] as const

export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

export function stripLocalePrefix(path: string) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`
  const pattern = new RegExp(`^/(${SUPPORTED_LOCALES.join('|')})(?=/|$)`)
  const strippedPath = normalizedPath.replace(pattern, '')

  return strippedPath || '/'
}

export function toDayjsLocale(locale: string) {
  return locale === 'de' ? 'de' : 'en'
}
